// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.message.type.SatelliteAiAutoResponseType

export enum SatelliteAiAutoResponseType {
  ELISE_AI = 'ELISE_AI',
  VAL_AI = 'VAL_AI',
}

export const SatelliteAiAutoResponseType_values = [
  SatelliteAiAutoResponseType.ELISE_AI,
  SatelliteAiAutoResponseType.VAL_AI,
] as const;
